import classNames from 'classnames';
import React, { ReactNode } from 'react';

type Sizes = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

interface Props {
    children?: ReactNode;
    className?: string;
    lg?: Sizes;
    lgPull?: Sizes;
    lgPush?: Sizes;
    md?: Sizes;
    mdPull?: Sizes;
    mdPush?: Sizes;
    sm?: Sizes;
    smPull?: Sizes;
    smPush?: Sizes;
    xs?: Sizes;
    xsPull?: Sizes;
    xsPush?: Sizes;
}

const Col = ({
    children,
    className,
    lg,
    lgPull,
    lgPush,
    md,
    mdPull,
    mdPush,
    sm,
    smPull,
    smPush,
    xs,
    xsPull,
    xsPush,
}: Props) => <div className={classNames(
    {
        'col-xs-12': !xs && !sm && !md && !lg,
        [`col-lg-${lg}`]: lg,
        [`col-lg-pull-${lgPull}`]: lgPull,
        [`col-lg-push-${lgPush}`]: lgPush,
        [`col-md-${md}`]: md,
        [`col-md-pull-${mdPull}`]: mdPull,
        [`col-md-push-${mdPush}`]: mdPush,
        [`col-sm-${sm}`]: sm,
        [`col-sm-pull-${smPull}`]: smPull,
        [`col-sm-push-${smPush}`]: smPush,
        [`col-xs-${xs}`]: xs,
        [`col-xs-pull-${xsPull}`]: xsPull,
        [`col-xs-push-${xsPush}`]: xsPush,
    },
    className
)}>{children}</div>;

export default Col;
